import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

type CanGoAloneOptionInput = {
  countryCode: string
  formulaId: number
  childBirthDate: string
  departureDate: string
  returnDate: string
}

export const canGoOutAloneOption = async (input: CanGoAloneOptionInput): Promise<boolean> => {
  return restApiClient
    .url(
      encodeNestedObject(
        constructApiUrl(API.canGoOutAloneCondition.getCanGoOutAloneOption.url, null),
        input
      )
    )
    .get<boolean>()
}
